enum BackgroundColor {
  BLUE = '#237AFF',
  GREEN = '#098961',
  PURPLE = '#8B1079',
}

export default BackgroundColor;
